import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/departments', request)
}

async function post(request) {
    return await postMethod('/api/departments', request)
}

async function put(departmentId, request) {
    return await putMethod(`/api/departments/${departmentId}`, request)
}

async function patch(departmentId, request) {
    return await patchMethod(`/api/departments/${departmentId}`, request)
}

export {get, post, put, patch}
